/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInboxItemTemplate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h11v9H2V2zm3.915 2L7.5 5.233 9.085 4h-3.17zM11 5.045 7.5 7.767 4 5.045V9h7V5.045zM22 8h-7V6h7v2zM2 13h11v9H2v-9zm3.915 2L7.5 16.233 9.085 15h-3.17zM11 16.045l-3.5 2.722L4 16.045V20h7v-3.955zM22 19h-7v-2h7v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgInboxItemTemplate as InboxItemTemplate };
